export default __webpack_public_path__ + "static/media/142.cce77bd9.jpg";